export const LocalTextSearchResultItem = (searchWord = '', resultString = '', isDeleted = false,
  isRestored = false, location = { start: -1, end: -1 }, meta = {}) => ({
  searchWord,
  resultString,
  isDeleted,
  isRestored,
  location,
  meta
})
